import {ThemeOptions} from '@mui/material';

export const desktop_light_theme: ThemeOptions = {
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
					cursor: 'pointer',
					userSelect: 'none',
					minWidth: 0,
				},
			},
			defaultProps: {
				disableElevation: true,
			},
		},
	},
	typography: {
		allVariants: {
			fontFamily: `"Inria Serif", serif`,
			color: '#6E6E6E',
		},
	},
	palette: {
		mode: 'light',
		primary: {
			main: '#3B3B3B',
			light: '#B5B5B5',
			dark: '#1B1B1B',
		},
		secondary: {
			main: '#CE93D8',
			light: '#F3E5F5',
			dark: '#AB47BC',
		},
		error: {
			main: '#F44336',
			light: '#E57373',
			dark: '#D32F2F',
		},
		warning: {
			main: '#FFA726',
			light: '#FFB74D',
			dark: '#F57C00',
		},
		info: {
			main: '#29B6F6',
			light: '#4FC3F7',
			dark: '#0288D1',
		},
		success: {
			main: '#66BB6A',
			light: '#81C784',
			dark: '#388E3C',
		},

		divider: '#FFFFFF1F',

		background: {
			paper: '#000000',
			default: '#000000',
		},
	},
};

export const mobile_light_theme: ThemeOptions = {
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					textTransform: 'none',
					cursor: 'pointer',
					userSelect: 'none',
					minWidth: 0,
				},
			},
			defaultProps: {
				disableElevation: true,
			},
		},
	},
	typography: {
		allVariants: {
			fontFamily: `"Inria Serif", serif`,
			color: '#6E6E6E',
		},
		h1: {
			fontSize: '48px',
			fontWeight: 400,
			lineHeight: '110%',
			letterSpacing: '-1.5px',
		},
		h2: {
			fontSize: '40px',
			fontWeight: 400,
			lineHeight: '110%',
			letterSpacing: '-0.5px',
		},
		h3: {
			fontSize: '32px',
			fontWeight: 400,
			lineHeight: '110%',
			letterSpacing: '0px',
		},
		h4: {
			fontSize: '24px',
			fontWeight: 400,
			lineHeight: '120%',
			letterSpacing: '0.25px',
		},
		h5: {
			fontSize: '20px',
			fontWeight: 400,
			lineHeight: '120%',
			letterSpacing: '0px',
		},
		h6: {
			fontSize: '15px',
			fontWeight: 400,
			lineHeight: '120%',
			letterSpacing: '0.15px',
		},
		subtitle1: {
			fontSize: '13px',
			fontWeight: 400,
			lineHeight: '120%',
			letterSpacing: '0.15px',
		},
		subtitle2: {
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '120%',
			letterSpacing: '0.1px',
		},
		body1: {
			fontSize: '13px',
			fontWeight: 400,
			lineHeight: '140%',
			letterSpacing: '0.5px',
		},
		body2: {
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '140%',
			letterSpacing: '0.25px',
		},
		button: {
			fontSize: '13px',
			fontWeight: 400,
			lineHeight: '140%',
			letterSpacing: '1.25px',
		},
		caption: {
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '140%',
			letterSpacing: '0.4px',
		},
		overline: {
			fontSize: '10px',
			fontWeight: 400,
			lineHeight: '140%',
			letterSpacing: '1.5px',
		},
	},

	palette: {
		mode: 'light',
		primary: {
			main: '#3B3B3B',
			light: '#B5B5B5',
			dark: '#1B1B1B',
		},
		secondary: {
			main: '#CE93D8',
			light: '#F3E5F5',
			dark: '#AB47BC',
		},
		error: {
			main: '#F44336',
			light: '#E57373',
			dark: '#D32F2F',
		},
		warning: {
			main: '#FFA726',
			light: '#FFB74D',
			dark: '#f57C00',
		},
		info: {
			main: '#29B6F6',
			light: '#4FC3F7',
			dark: '#0288D1',
		},
		success: {
			main: '#66BB6A',
			light: '#81C784',
			dark: '#388E3C',
		},

		text: {
			primary: '#3B3B3B',
			secondary: '#202020',
			disabled: '#FFFFFF80',
		},

		divider: '#FFFFFF1F',

		background: {
			paper: '#000000',
			default: '#000000',
		},
	},
};
